import { updateFormGroup } from "../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { recordSentry } from "./recordSentry";
import { FormGroup } from "db/definitions";

async function updateFormGroupAmplify(data: FormGroup) {
	try {
		const input = {
			id: data.id,
			users: data.users,
			name: data.name,
			type: data.type,
			formOrder: data.formOrder,
			group: data.group,
			updatedAt: data.updatedAt || new Date().toISOString(),
		};
		const client = generateClient({ authMode: "userPool" });
		await client.graphql({
			query: updateFormGroup,
			variables: {
				input,
			},
			authMode: "userPool",
		});
	} catch (err) {
		recordSentry({ error: err, msg: "Error updating form group:", showModal: true });
	}
}

export default updateFormGroupAmplify;
